// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1LVA4","head":"Table_head__3EBTo","col":"Table_col__1xxU3"};